module.exports = __webpack_public_path__ + "static/media/delay_icon-light.af4d460b.svg";